import { SxProps, Theme } from '@mui/material';

export const helperTextSx: SxProps<Theme> = {
  '& .MuiFormHelperText-root': {
    fontStyle: 'italic',
    marginTop: '4px',
    marginBottom: '24px',
    opacity: 0.8,
  },
};
